/**************************************************
 * Nombre:       Formulario_Categoria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {CategoryOutlined,SortByAlphaOutlined} from "@mui/icons-material";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Categoria = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} alto={2} ancho={3} {...props} />
                </Grid>

                <Grid container size={8}>
                    <IngresoTexto Icono={CategoryOutlined} nombre={'Nombre de categoria'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={4}>
                    <IngresoTexto Icono={SortByAlphaOutlined} nombre={'Prioridad'}
                                  dato={'prioridad'} {...props} type={'number'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Categoria